import { FC, useEffect } from 'react';
import InputPassword from "@common/ui-kit/inputs/input_password";
import { EventNameComponentProps } from '@pages/makeEvent/types';
import NameSchema from '@pages/makeEvent/steps-components/eventName-component/schema.ts';
import { useValidation } from "@pages/makeEvent/hooks/useValidation";


const fieldName = 'event_name' as const

const EventNameComponent: FC<EventNameComponentProps> = ({ formik, setValidValue }) => {
	const validationData = { [fieldName]: formik.values[fieldName] }
  const { status: validationStatus, errors: validationErrors } = useValidation(NameSchema, validationData);

	useEffect(() => {
		const validValue = validationStatus === 'success' ? formik.values.event_name : null
		setValidValue(validValue)
	}, [formik.values.event_name])

	return (
		<InputPassword
			name={fieldName}
			value={formik.values[fieldName]}
			handleChange={formik.handleChange(fieldName)}
			type={"text"}
			autocomplete="off"
			placeholder={"Название"}
			errorText={formik.touched[fieldName] && validationErrors[fieldName] ? validationErrors[fieldName] : null}
			onBlur={formik.handleBlur}
		/>
	)
}

export default EventNameComponent